import custPopover from '@/components/cust_components/cust_popover_component.vue';
import headerComponent from '@/components/cust_components/cust_header_component.vue';
import FooterComponent from '@/components/cust_components/cust_footer_component.vue';
import utils from '../../js/utils.js';
import LoaderPopover from '@/components/loaderpopover_component.vue';

export default {
    name: 'bookingsuccessComp',
    components:{
        custPopover,
        headerComponent,
        FooterComponent,
        LoaderPopover,
    },
    data(){
        return {
            mobile_view : false,
            successPopUp : true,
            all_bookings:[],
            product_details : [],
            total_product_sum:0, 
            product_due_amount : 0,
            product_paid_amount : 0,
            cust_name: JSON.parse(this.$session.get('cust_details')).cust_first_name
        }
    },
    mounted(){     
        this.$session.remove('preview_booking_flag');
        this.$session.remove('store_details');
        this.$session.remove('service_obj');
        this.$session.remove('product_obj');
        this.$session.remove('cust_banned_data');
        this.get_Customer_Booking_Details();
        this.responsive_view();
        window.addEventListener('resize', this.responsive_view);
      
    },
   
    methods:{
        async get_Customer_Booking_Details(){

            this.$store.state.loader_popup = true;

            if(this.$session.get('unpaid_booking_details')){
                var book_ids = JSON.parse(this.$session.get('unpaid_booking_details'));
            }
            
            await this.$store.dispatch('getCustomerBookings',[this.$store.state.api,book_ids])
           
            let bookings = this.$store.state.cust_bookings_data.service_bookings;

            this.product_details = this.$store.state.cust_bookings_data.product_bookings;

            
            bookings.forEach(service_bookings => {

                let created_date =  service_bookings.date;
                
                if(!(created_date in this.all_bookings)){
                    this.all_bookings[created_date] = {};
                    this.all_bookings[created_date]["service_bookings"] = [];
                }
                this.all_bookings[created_date]["service_bookings"].push(service_bookings);
            });

            this.all_bookings = Object.keys(this.all_bookings).sort().reduce(
                (obj, key) => { 
                  obj[key] = this.all_bookings[key]; 
                  return obj;
                }, 
                {}
            );

            for (let [date,date_bookings] of Object.entries(this.all_bookings)) {
               let total_services_sum = 0;
               let service_paid_amount =0;

                date_bookings.service_bookings.forEach(bookings => {

                    if(bookings.book_discount_full_amount >= 0){
                        total_services_sum  +=  parseFloat(bookings.book_discount_full_amount);
                    }else{
                        total_services_sum  +=  parseFloat(bookings.service_price);
                    } 
                      
                    service_paid_amount +=  parseFloat(bookings.paid_amount);
                      
                });

                this.all_bookings[date]['services_sum'] =  total_services_sum;
                this.all_bookings[date]['paid_amount'] =  service_paid_amount;
                this.all_bookings[date]['due_amount'] =  Math.abs((parseFloat(total_services_sum) -  parseFloat(service_paid_amount))*100/100);
              
            }

            this.product_details.forEach(product => {
                if(product.product_discount_full_amount >= 0){
                    this.total_product_sum  += parseFloat(product.product_discount_full_amount) * (product.product_quantity);
                }else{
                    this.total_product_sum  +=  parseFloat(product.product_full_amount) * (product.product_quantity);
                } 

                this.product_paid_amount += parseFloat(product.product_paid_amount);

            });

            this.product_due_amount = parseFloat(this.total_product_sum) - parseFloat(this.product_paid_amount);

            this.$store.state.loader_popup = false;
            this.$ga.page(this.$router);
        },

        async responsive_view(){
            await this.$store.commit('responsive_view', window.innerWidth)
        },

        close_success_popup(){
            this.successPopUp = false;
        },

        home_button()
        {
            this.$session.remove('store_details');
            this.$session.remove('service_obj');
            this.$session.remove('product_obj');
            this.$session.remove('unpaid_booking_details');
            this.$session.remove('cust_banned_data');
            this.$router.push('/home/'+ this.$store.state.store_url_name)
        },
        myBookings_redirect()
        {
            this.$session.remove('store_details');
            this.$session.remove('service_obj');
            this.$session.remove('product_obj');
            this.$session.remove('unpaid_booking_details');
            this.$session.remove('cust_banned_data');
            this.$router.push('/mybookings')
        }
    },
    filters: {
        human_date_format: function (date,timezone,date_format) {
            return utils.human_date_format(date,timezone,date_format)
        },
        time_12hrs_format:function(time,time_format){
            return utils.time_12hrs_format(time,time_format)
        }
    }
}